(function () {
	'use strict';

	/**
	* @ngdoc service
	* @name  smb-app.smbUserDataStore
	* 
	* @description 
	* A datastore used to retrieve and interact with a smb-app user
	**/

	angular
		.module('smb-app')
		.factory('smbUserDataStore',
		[
			'$q',
			'pxAuthService',
			'sbUserService',
			UserDataStore
		]);

	function UserDataStore($q, pxAuthService, sbUserService) {
		var _user = null;
		var _newUser = {
			'UserName': null,
			'EmailAddress': null,
			'Password': null,
			'Embedded': {
				'Roles': []
			}
		};

		return {
			/**
			* @ngdoc method
			* @name smbUserDataStore#getUser
			* @methodOf smb-app.smbUserDataStore
			* @kind function
			*
			* @description
			* Gets a user
			*
			* @returns {Deferred} A promise that will resolve with a user
			* 
			*/
			getUser: getUser,

			/**
			* @ngdoc method
			* @name smbUserDataStore#addUser
			* @methodOf smb-app.smbUserDataStore
			* @kind function
			*
			* @description
			* Adds a new user
			*
			* @returns {Deferred} A promise that will resolve with a new user
			* 
			*/
			addUser: addUser,

			/**
			* @ngdoc method
			* @name smbUserDataStore#updateUser
			* @methodOf smb-app.smbUserDataStore
			* @kind function
			*
			* @description
			* Gets an updated user
			*
			* @returns {Deferred} A promise that will resolve with an updated user
			* 
			*/
			updateUser: updateUser,

			/**
			* @ngdoc method
			* @name smbUserDataStore#lockUser
			* @methodOf smb-app.smbUserDataStore
			* @kind function
			*
			* @description
			* Locks a user
			*
			* @returns {Deferred} A promise that will resolve
			* 
			*/
			lockUser: lockUser,

			/**
			* @ngdoc method
			* @name smbUserDataStore#unlockUser
			* @methodOf smb-app.smbUserDataStore
			* @kind function
			*
			* @description
			* Unlocks a user
			*
			* @returns {Deferred} A promise that will resolve
			* 
			*/
			unlockUser: unlockUser,

			/**
			* @ngdoc property
			* @name smbUserDataStore#user
			* @propertyOf smb-app.smbUserDataStore
			* @kind property
			*
			* @description
			* A user
			* 
			* @returns {object} A user
			*/
			get user() { return _user; },
			
			/**
			* @ngdoc property
			* @name smbUserDataStore#isSiteAdmin
			* @propertyOf smb-app.smbUserDataStore
			* @kind property
			*
			* @description
			* Set user site admin role
			*/
			set isSiteAdmin(val) { setSiteAdmin(val); setUserAdmin(val);},
			
			/**
			* @ngdoc property
			* @name smbUserDataStore#isSiteAdmin
			* @propertyOf smb-app.smbUserDataStore
			* @kind property
			*
			* @description
			* Get user site admin role
			*/
			get isSiteAdmin() { return _user ? _user.Embedded.Roles.indexOf('SiteAdmin') > -1 : false;},
			/**
			* @ngdoc property
			* @name smbUserDataStore#isUsereAdmin
			* @propertyOf smb-app.smbUserDataStore
			* @kind property
			*
			* @description
			* Set user user admin role
			*/
			set isUserAdmin(val) { setUserAdmin(val);},
			
			/**
			* @ngdoc property
			* @name smbUserDataStore#isUsereAdmin
			* @propertyOf smb-app.smbUserDataStore
			* @kind property
			*
			* @description
			* Get user user admin role
			*/
			get isUserAdmin() { return _user ? _user.Embedded.Roles.indexOf('UserAdmin') > -1 : false;}
		};

		function getUser(userId) {
			if (!userId) {
				_user = angular.copy(_newUser);
				return $q.resolve(_user);
			}
			return sbUserService.getUser(userId, pxAuthService.deploymentId).then(function (response) {
				//clean duplicate roles
				response.Embedded.Roles = response.Embedded.Roles.filter(function (v, i, a) { return a.indexOf(v) === i; });
				_user = response;

				return response;
			});
		}

		function addUser(user) {
			return sbUserService.addUser(user, pxAuthService.systemName).then(function (response) {
				return response;
			});
		}

		function updateUser(user) {
			return sbUserService.updateUser(user, pxAuthService.deploymentId).then(function (response) {
				return response;
			});
		}

		function lockUser(userId) {
			return sbUserService.lockUser(userId, pxAuthService.deploymentId).then(function (response) {
				return response;
			});
		}

		function unlockUser(userId) {
			return sbUserService.unlockUser(userId, pxAuthService.deploymentId).then(function (response) {
				return response;
			});
		}

		function setSiteAdmin(val) {
			var index = _user.Embedded.Roles.indexOf('SiteAdmin');
			if (!val && index > -1) {
				//remove role
				_user.Embedded.Roles.splice(index, 1);
				return;
			}

			if (val && index === -1) {
				//add role
				_user.Embedded.Roles.push('SiteAdmin');
				return;
			}
		}

		function setUserAdmin(val) {
			var index = _user.Embedded.Roles.indexOf('UserAdmin');
			if (!val && index > -1) {
				//remove role
				_user.Embedded.Roles.splice(index, 1);
				return;
			}

			if (val && index === -1) {
				//add role
				_user.Embedded.Roles.push('UserAdmin');
				return;
			}
		}
	}

})();


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/userDataStore.js
// module id = 130
// module chunks = 1